<div class="desktop-filter">
  @if (finalContainer$ | async; as containerModel) {
    <div class="filter-section">
      <div class="filter-header">
        <div class="filter-title">
          <div class="title">{{ containerModel?.title | titlecase }}</div>
          <span class="clr-btn" (click)="clearAllFilter()">Clear</span>
        </div>
      </div>
      <div class="sticky-scroll">
        <div class="ion-no-padding">
          @for (containerItem of containerModel?.data; track containerItem) {
            @if (containerItem?.component) {
              @switch (containerItem?.component) {
                @case ('NewCheckboxListComponent') {
                  <app-b2b-new-checkbox-list
                    [compData]="{
                        containerItem: containerItem,
                        preSelectedValues: eventService?.filterValueContainer?.selectedValues
                    }"
                    (selectEvent)="onFilterChange($event, containerItem)"
                  ></app-b2b-new-checkbox-list>
                }
                @case ('NewRadioCheckboxListComponent') {
                  <app-b2b-new-radio-checkbox-list
                    [compData]="{
                      containerItem: containerItem,
                      preSelectedValues: eventService?.filterValueContainer?.selectedValues
                    }"
                    (selectEvent)="onFilterChange($event, containerItem)"
                  ></app-b2b-new-radio-checkbox-list>
                }
              }
            }
          }
        </div>
      </div>
    </div>
  }
</div>
